import {
  TRANSACTION_RULE_FETCH_REQUEST,
  TRANSACTION_RULE_FETCH_REQUEST_SUCCESS,
  TRANSACTION_RULE_FETCH_REQUEST_FAILURE,
  TRANSACTION_RULE_ADD_REQUEST,
  TRANSACTION_RULE_ADD_REQUEST_SUCCESS,
  TRANSACTION_RULE_ADD_REQUEST_FAILURE,
  TRANSACTION_RULE_UPDATE_REQUEST,
  TRANSACTION_RULE_UPDATE_REQUEST_SUCCESS,
  TRANSACTION_RULE_UPDATE_REQUEST_FAILURE,
  TRANSACTION_RULE_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const transactionRulesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TRANSACTION_RULE_FETCH_REQUEST:
    case TRANSACTION_RULE_ADD_REQUEST:
    case TRANSACTION_RULE_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TRANSACTION_RULE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
        },
      });

    case TRANSACTION_RULE_ADD_REQUEST_SUCCESS:
    case TRANSACTION_RULE_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TRANSACTION_RULE_FETCH_REQUEST_FAILURE:
    case TRANSACTION_RULE_ADD_REQUEST_FAILURE:
    case TRANSACTION_RULE_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TRANSACTION_RULE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default transactionRulesReducer;
